export const radii = {
  none: "0",
  small: "0.125rem",
  medium: "0.25rem",
  large: "0.5rem",
  navigation: "0 6.25rem 6.25rem 0",
  right: "0 0.375rem 0.375rem 0",
  rounded: "50%"
};
